function callObj(url, obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`https://bloom.aumentar.com.co/${url}`, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(obj)
        });
        const resp = await response.json();
        resolve(resp);
      } catch (error) {
        reject(error);
      }
    })
  }
  function callPutObj(url, obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`https://bloom.aumentar.com.co/${url}`, {
          method: "PUT",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(obj)
        });
        const resp = await response.json();
        resolve(resp);
      } catch (error) {
        reject(error);
      }
    })
  }
  function callParams(url, obj) {
    let params = "";
    for (const key in obj) {
      params += `${key}=${obj[key]}&`;
    }
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`https://bloom.aumentar.com.co/${url}?${params}`);
        const resp = await response.json();
        resolve(resp);
      } catch (error) {
        reject(error);
      }
    })
  }
  function formsAData(form_query, callback) {
    document.querySelector(form_query).addEventListener('submit', function (event) {
      event.preventDefault();
      const formData = new FormData(event.target);
      let jsonObject = {};
      formData.forEach((value, key) => {
        jsonObject[key] = value;
      });
      callback(jsonObject, event.target);
    })
  }
  function formsData(form_query, callback) {
    let formulario=document.querySelector(form_query)
      const formData = new FormData(formulario);
      let jsonObject = {};
      formData.forEach((value, key) => {
        jsonObject[key] = value;
      });
      callback(jsonObject, formulario);
  }
  function callUser() {
      callParams("user/petals", { user_id: globalId }).then(r => {
          let data = r.data;
          let circle_petals = document.querySelector(".circle_petals")
          circle_petals.querySelector(".number").innerHTML = data.petals;
          circle_petals.querySelector(".category").innerHTML = data.category;
          
          document.querySelector(".profile_welcome .name").innerHTML = data.profile.firstName + " " + data.profile.lastName;
          document.querySelector("#rangePetals").max = r.data.petals
          let cantidadLlenado = 0;
          let faltante=0;
          if (data.category.toLowerCase().includes("silver")) {
              cantidadLlenado = (data.petals /500) * 100;
              faltante=500-data.petals ;
          } else if (data.category.toLowerCase().includes("golden")) {
              cantidadLlenado = (data.petals /1000) * 100;
              faltante = 1000 - data.petals;
          } else {
              cantidadLlenado = (r.data.petals /200) * 100;
              faltante = 200 - r.data.petals;
          }
          
          document.querySelector("#rangePetals").max = data.petals
          circle_petals.querySelector(".description").innerHTML=`You need ${faltante} petals for level up` 
          circle_petals.style.setProperty('--circle-size', (380/cantidadLlenado)+'deg');
          

      })
  }